import React, {useEffect, useState} from "react";
import {
	Routes,
	Route,
	useLocation,
	Navigate,
	useNavigate,
} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import Loading from "@/components/Loading";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SideMenu from "@/components/SideMenu";

import AthleticTestsPage from "@/pages/Manager/AthleticTests";
import AthleticTestPage from "@/pages/Manager/AthleticTest";
import SettingsCategoriesPage from "@/pages/Settings/Categories";
import ClubsPage from "@/pages/Clubs";
import ExercisePage from "@/pages/Settings/Exercise";
import ExercisesPage from "@/pages/Settings/Exercises";
import HandleAthleticTestPage from "@/pages/Manager/HandleAthleticTest";
import HandleClubPage from "@/pages/HandleClub";
import HandleExercisePage from "@/pages/Settings/HandleExercise";
import HandleMatchPage from "@/pages/Manager/HandleMatch";
import HandleMatchReportPage from "@/pages/MatchReports/HandleMatchReport";
import HandleMedicalInjuryPage from "@/pages/Medical/HandleInjury";
import HandleMovementPage from "@/pages/Settings/HandleMovement";
import HandlePlayerPage from "@/pages/HandlePlayer";
import HandleRosterPage from "@/pages/Rosters/Modals/handleRoster";
import HandleScoutClubPage from "@/pages/Scouting/Clubs/HandleClub";
import HandleScoutingStaffPage from "@/pages/Scouting/Staffs/HandleStaff";
import HandleScoutingMatchPage from "@/pages/Scouting/Matches/HandleMatch";
import HandleScoutingPlayerPage from "@/pages/Scouting/Players/HandlePlayer";
import HandleScoutingReportPage from "@/pages/Scouting/ScoutReports/HandleScoutReport";
import HandleSettingsCategoryPage from "@/pages/Settings/Categories/HandleCategory";
import HandleSettingsTeamPage from "@/pages/Settings//Teams/HandleTeam";
import ManagerHandleStaffPage from "@/pages/HandleStaff";
import HandleStaffRolePage from "@/pages/Settings/HandleStaffRole";
import HandleStaffUnitPage from "@/pages/Settings/HandleStaffUnit";
import HandleTargetPage from "@/pages/HandleTarget";
import HandleTQRPage from "@/pages/HandleTQR";
import HandleTrainingPage from "@/pages/Manager/HandleTraining";
import HandleUserPage from "@/pages/Settings/HandleUser";
import HandleUserRolePage from "@/pages/Settings/HandleUserRole";
import HandleValuationPage from "@/pages/Valuations/HandleValuation";
import HandleTryoutPage from "@/pages/Scouting/Tryouts/HandleTryout";
// import HandleProspectPlayersReportPage from "@/pages/Scouting/ProspectPlayersReports/HandleProspectPlayersReport";
import HandleVASPage from "@/pages/HandleVAS";
import HandleVideoPage from "@/pages/HandleVideo";
import HomePage from "@/pages/Home";
import MedicalInjuryPage from "@/pages/Medical/Injury";
import LoginPage from "@/pages/Login";
import DirectorDashboardPage from "@/pages/Director/Dashboard";
import ManagerHandleFootballTeamPage from "@/pages/Manager/FootballTeams/HandleFootballTeam";
import ManagerFootballTeamPage from "@/pages/Manager/FootballTeams/FootballTeam";
import ManagerFootballTeamsPage from "@/pages/Manager/FootballTeams";
import ManagerPlayersPage from "@/pages/Players";
import PlayersComparisonPage from "@/pages/Players/Comparison";
import MatchPage from "@/pages/Manager/Match";
import MatchAdvancedStatsFormPage from "@/pages/Manager/MatchAdvancedStats";
import MatchesPage from "@/pages/Matches";
import MatchesCalendarPage from "@/pages/MatchesCalendar";
import MatchReportPage from "@/pages/MatchReports/MatchReport";
import MatchReportsPage from "@/pages/MatchReports";
import MedicalRecordPage from "@/pages/Medical/Record";
import MedicalRecordsPage from "@/pages/Medical/Records";
import MovementsPage from "@/pages/Settings/Movements";
import PlayerPage from "@/pages/Player";
import PlayerProfilePage from "@/pages/PlayerProfile";
import ManagerGoalkeepersPage from "@/pages/Goalkeepers";
import RPEPage from "@/pages/RPE";
import ScoutingRosterPage from "@/pages/Rosters/Roster";
import ScoutingRostersPage from "@/pages/Rosters";
import ScoutClubPage from "@/pages/Scouting/Clubs/Club";
import ScoutClubsPage from "@/pages/Scouting/Clubs";
import ScoutingStaffPage from "@/pages/Scouting/Staffs/Staff";
import ScoutingStaffsPage from "@/pages/Scouting/Staffs";
import ScoutingMatchPage from "@/pages/Scouting/Matches/Match";
import ScoutingMatchesPage from "@/pages/Scouting/Matches";
import ScoutingDatabasePage from "@/pages/Scouting/Players";
import ScoutingPlayerPage from "@/pages/Scouting/Players/Player";
import ScoutingDashboardPage from "@/pages/Scouting/Dashboard";
import ScoutingInternalComparisonPage from "@/pages/Scouting/InternalComparison";
import ScoutingReportPage from "@/pages/Scouting/ScoutReports/ScoutReport";
import ScoutingReportsPage from "@/pages/Scouting/ScoutReports";
import ScoutValuationPage from "@/pages/Valuations/ScoutValuation";
import SettingsTeamsPage from "@/pages/Settings/Teams";
import ManagerStaffPage from "@/pages/Staff";
import ManagerStaffsPage from "@/pages/Staffs";
import StaffRolePage from "@/pages/Settings/StaffRole";
import StaffRolesPage from "@/pages/Settings/StaffRoles";
import StaffUnitPage from "@/pages/Settings/StaffUnit";
import StaffUnitsPage from "@/pages/Settings/StaffUnits";
import TargetPage from "@/pages/Target";
import TargetsPage from "@/pages/Targets";
import TQRPage from "@/pages/TQR";
import TrainingPage from "@/pages/Manager/Training";
import TrainingExercisesPage from "@/pages/Manager/TrainingExercises";
import TrainingsPage from "@/pages/Manager/Trainings";
import UserRolePage from "@/pages/Settings/UserRole";
import UserRolesPage from "@/pages/Settings/UserRoles";
import UserPage from "@/pages/Settings/User";
import UsersPage from "@/pages/Settings/Users";
import ValuationPage from "@/pages/Valuations/Valuation";
import ValuationsPage from "@/pages/Valuations";
import TryoutPage from "@/pages/Scouting/Tryouts/Tryout";
import TryoutsPage from "@/pages/Scouting/Tryouts";
// import ProspectPlayersReportPage from "@/pages/Scouting/ProspectPlayersReports/ProspectPlayersReport";
// import ProspectPlayersReportsPage from "@/pages/Scouting/ProspectPlayersReports";
import VASPage from "@/pages/VAS";
import VideoPage from "@/pages/Video";
import VideosPage from "@/pages/Videos";

import {AuthorizationAPI} from "@/api/authorization";
import {SeasonAPI} from "@/api/season";

import {
	loginSuccess,
	logout,
	setSelectedMenuItem as setGeneralSelectedMenuItem,
	userSuccess,
} from "@/actions";

import {theme} from "@/style/utils.js";
import {ThemeProvider} from "@mui/material/styles";

import {headerMenuItems, ERROR_OPERATION} from "@/utils/constants";
import {orderByDate} from "@/utils/functions";

import "@/style/App.scss";

const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

function Layout({children}) {
	const dispatch = useDispatch();
	const {t} = useTranslation();

	const seasonId = useSelector((state) => state?.season?.id);
	const selectedMenuItem = useSelector((state) => state?.selectedMenuItem);
	const userRole = useSelector((state) => state?.user?.roleName);

	const location = useLocation();
	const navigate = useNavigate();

	const visibleHeaderMenuItems = headerMenuItems(t).filter(
		(item) => item.roles.indexOf(userRole?.toLowerCase()) !== -1,
	);

	useEffect(() => {
		if (userRole) {
			const currentPath = location.pathname.split("/")?.[1];
			const selectedItem =
				currentPath &&
				visibleHeaderMenuItems.map((i) => i.value).indexOf(currentPath) !== -1
					? currentPath
					: visibleHeaderMenuItems[0]?.value;
			dispatch(setGeneralSelectedMenuItem(selectedItem));
		}
	}, [userRole]);

	if (!userRole || !selectedMenuItem || !seasonId) {
		return <Loading visible />;
	}

	return (
		<div className="layout-container">
			<div className="layout">
				<div className="layout-side">
					<div className="header-menu-container">
						<div className="logo" onClick={() => navigate("/")} />
						<div className="header-menu-items">
							{visibleHeaderMenuItems.map((item, key) => {
								return (
									<div
										key={key}
										className={
											"header-menu-item" +
											(selectedMenuItem === item.value ? " selected" : "")
										}
										onClick={() => {
											if (location.pathname.split("/")?.[1] !== item.value) {
												navigate("/");
											}
											dispatch(setGeneralSelectedMenuItem(item.value));
										}}
									>
										<img className="item-icon" src={item.image} alt="" />
										<span className="item-label">{item.label}</span>
									</div>
								);
							})}
						</div>
					</div>
					<div className="d-flex">
						<SideMenu />
						{children}
					</div>
				</div>
			</div>
		</div>
	);
}

function RequireAuth({isLoggedIn, handleNotification, children}) {
	let location = useLocation();

	if (!isLoggedIn) {
		return <Navigate to="/login" state={{from: location}} replace />;
	}

	const childWithProps = React.Children.only(children);

	return (
		<ThemeProvider theme={theme}>
			<Layout>
				{React.cloneElement(childWithProps, {handleNotification})}
			</Layout>
		</ThemeProvider>
	);
}

function App() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isLoggedIn = useSelector((state) => state.isLoggedIn);

	const [loading, setLoading] = useState(true);
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [severity, setSeverity] = useState("info");

	const handleClose = () => {
		setOpen(false);
	};

	const handleNotification = (newMessage, newSeverity = "info") => {
		setMessage(newMessage);
		setSeverity(newSeverity);
		setOpen(true);
	};

	useEffect(() => {
		if (isLoggedIn) {
			const getUserData = async () => {
				try {
					const response = await AuthorizationAPI.getUserData();
					const storedSeasonId = localStorage.getItem("seasonId");
					const seasons = await SeasonAPI.allSeasons();
					const sortedSeasons = orderByDate(seasons, "startDate");
					const selectedSeason =
						sortedSeasons.find((s) => s.id === storedSeasonId || s.current) ||
						sortedSeasons[sortedSeasons.length - 1];

					dispatch(
						userSuccess({
							user: response,
							season: selectedSeason,
							seasons: sortedSeasons,
						}),
					);
				} catch (error) {
					handleNotification(ERROR_OPERATION, "error");
					dispatch(logout());
					navigate("/login");
				}
			};

			getUserData();
		}
	}, [dispatch, isLoggedIn]);

	useEffect(() => {
		window.addEventListener("resize", documentHeight);
		documentHeight();

		const checkToken = async (token) => {
			try {
				await AuthorizationAPI.verifyToken(token);
				dispatch(loginSuccess(token));
			} catch (error) {
				dispatch(logout());
			} finally {
				setLoading(false);
			}
		};

		const savedToken = localStorage.getItem("token");
		if (savedToken) {
			setLoading(true);
			checkToken(savedToken);
		} else {
			setLoading(false);
		}
	}, [dispatch]);

	const authRoutes = [
		{component: <HomePage />, path: "/"},
		{component: <ManagerStaffsPage />, path: "/manager/staffs"},
		{component: <ManagerStaffPage />, path: "/manager/staffs/:id"},
		{component: <ManagerHandleStaffPage />, path: "/manager/staffs/new"},
		{
			component: <ManagerHandleStaffPage edit />,
			path: "/manager/staffs/:id/edit",
		},
		{component: <ManagerPlayersPage />, path: "/players"},
		{component: <PlayersComparisonPage />, path: "/manager/players-comparison"},
		{component: <ManagerGoalkeepersPage />, path: "/goalkeepers"},
		{component: <PlayerPage />, path: "/players/:id"},
		{component: <HandlePlayerPage />, path: "/players/new"},
		{component: <HandlePlayerPage edit />, path: "/players/:id/edit"},
		{component: <ValuationPage />, path: "/players-valuations/:id"},
		{component: <HandleValuationPage />, path: "/players-valuations/new"},
		{
			component: <HandleValuationPage edit />,
			path: "/players-valuations/:id/edit",
		},
		{
			component: <ValuationsPage external />,
			path: "/scouting/valuations",
		},
		{component: <ValuationPage external />, path: "/scouting/valuations/:id"},
		{
			component: <ScoutValuationPage external />,
			path: "/scouting/scout-valuations/:id",
		},
		{
			component: <HandleValuationPage external />,
			path: "/scouting/valuations/new",
		},
		{
			component: <HandleValuationPage edit external />,
			path: "/scouting/valuations/:id/edit",
		},
		{
			component: <TryoutsPage />,
			path: "/scouting/tryouts",
		},
		{component: <TryoutPage />, path: "/scouting/tryouts/:id"},
		{
			component: <HandleTryoutPage />,
			path: "/scouting/tryouts/new",
		},
		{
			component: <HandleTryoutPage edit />,
			path: "/scouting/tryouts/:id/edit",
		},
		// {
		// 	component: <ProspectPlayersReportsPage />,
		// 	path: "/scouting/prospect-players-reports",
		// },
		// {
		// 	component: <ProspectPlayersReportPage />,
		// 	path: "/scouting/prospect-players-reports/:id",
		// },
		// {
		// 	component: <HandleProspectPlayersReportPage />,
		// 	path: "/scouting/prospect-players-reports/new",
		// },
		// {
		// 	component: <HandleProspectPlayersReportPage edit />,
		// 	path: "/scouting/prospect-players-reports/:id/edit",
		// },

		{component: <SettingsCategoriesPage />, path: "/settings/categories"},
		{
			component: <HandleSettingsCategoryPage />,
			path: "/settings/categories/new",
		},
		{
			component: <HandleSettingsCategoryPage edit />,
			path: "/settings/categories/:id/edit",
		},
		{component: <ClubsPage />, path: "/settings/clubs"},
		{component: <HandleClubPage />, path: "/settings/clubs/new"},
		{
			component: <HandleClubPage edit />,
			path: "/settings/clubs/:id/edit",
		},
		{component: <SettingsTeamsPage />, path: "/settings/teams"},
		{component: <HandleSettingsTeamPage />, path: "/settings/teams/new"},
		{
			component: <HandleSettingsTeamPage edit />,
			path: "/settings/teams/:id/edit",
		},
		...["/trainings"].map((path) => ({
			path,
			component: <TrainingsPage />,
		})),
		...["/trainings/:id"].map((path) => ({
			path,
			component: <TrainingPage />,
		})),
		...["/trainings/:id/exercises"].map((path) => ({
			path,
			component: <TrainingExercisesPage />,
		})),
		...["/trainings/new"].map((path) => ({
			path,
			component: <HandleTrainingPage />,
		})),
		...["/trainings/admin/new"].map((path) => ({
			path,
			component: <HandleTrainingPage admin />,
		})),
		...["/trainings/:id/edit"].map((path) => ({
			path,
			component: <HandleTrainingPage edit />,
		})),
		...["/matches"].map((path) => ({
			path,
			component: <MatchesPage />,
		})),
		{
			component: <MatchAdvancedStatsFormPage />,
			path: "/matches/:id/advanced-stats",
		},
		...["/match-calendar"].map((path) => ({
			path,
			component: <MatchesCalendarPage />,
		})),
		...["/matches/:id"].map((path) => ({
			path,
			component: <MatchPage />,
		})),
		...["/matches/new"].map((path) => ({
			path,
			component: <HandleMatchPage />,
		})),
		...["/matches/:id/edit"].map((path) => ({
			path,
			component: <HandleMatchPage edit />,
		})),
		...["/match-reports"].map((path) => ({
			path,
			component: <MatchReportsPage fullpage />,
		})),
		...["/match-reports/new"].map((path) => ({
			path,
			component: <HandleMatchReportPage />,
		})),
		...["/match-reports/:id"].map((path) => ({
			path,
			component: <MatchReportPage />,
		})),
		...["/match-reports/:id/edit"].map((path) => ({
			path,
			component: <HandleMatchReportPage edit />,
		})),
		{component: <TQRPage />, path: "/measurations/tqr"},
		{component: <RPEPage />, path: "/measurations/rpe"},
		{component: <VASPage />, path: "/measurations/vas"},
		{component: <HandleTQRPage />, path: "/measurations/tqr/new"},
		{component: <HandleVASPage />, path: "/measurations/vas/new"},
		{component: <AthleticTestsPage />, path: "/athletic-tests"},
		{component: <AthleticTestPage />, path: "/athletic-tests/:id"},
		{component: <HandleAthleticTestPage />, path: "/athletic-tests/new"},
		{
			component: <HandleAthleticTestPage edit />,
			path: "/athletic-tests/:id/edit",
		},
		{component: <VideosPage />, path: "/video"},
		{component: <VideoPage />, path: "/video/:id"},
		{component: <HandleVideoPage />, path: "/video/new"},
		{component: <HandleVideoPage edit />, path: "/video/:id/edit"},
		{component: <TargetsPage />, path: "/development/targets"},
		{component: <TargetPage />, path: "/development/targets/:id"},
		{component: <HandleTargetPage />, path: "/development/targets/new"},
		{
			component: <HandleTargetPage edit />,
			path: "/development/targets/:id/edit",
		},
		{component: <MedicalRecordsPage />, path: "/medical/records"},
		{component: <MedicalRecordPage />, path: "/medical/records/:id"},
		{
			component: <MedicalInjuryPage />,
			path: "/medical/records/:recordId/injuries/:id",
		},
		{
			component: <HandleMedicalInjuryPage />,
			path: "/medical/records/:id/injuries/new",
		},
		{
			component: <HandleMedicalInjuryPage edit />,
			path: "/medical/records/:id/injuries/:injuryId/edit",
		},
		{component: <ScoutingDashboardPage />, path: "/scouting/dashboard"},
		{
			component: <ScoutingInternalComparisonPage />,
			path: "/scouting/internal-comparison",
		},
		{component: <ScoutingReportsPage />, path: "/scouting/reports"},
		{component: <ScoutingReportPage />, path: "/scouting/reports/:id"},
		{component: <HandleScoutingReportPage />, path: "/scouting/reports/new"},
		{
			component: <HandleScoutingReportPage edit />,
			path: "/scouting/reports/:id/edit",
		},
		{component: <ScoutingMatchesPage />, path: "/scouting/planning"},
		{component: <ScoutingMatchPage />, path: "/scouting/planning/:id"},
		{
			component: <HandleScoutingMatchPage edit />,
			path: "/scouting/planning/:id/edit",
		},
		{component: <HandleScoutingMatchPage />, path: "/scouting/planning/new"},
		{component: <ScoutClubsPage />, path: "/scout-clubs"},
		{component: <ScoutClubPage />, path: "/scout-clubs/:id"},
		{component: <HandleScoutClubPage edit />, path: "/scout-clubs/:id/edit"},
		{component: <HandleScoutClubPage />, path: "/scout-clubs/new"},
		{component: <ScoutingStaffsPage />, path: "/scouting/staffs"},
		{component: <ScoutingStaffPage />, path: "/scouting/staffs/:id"},
		{
			component: <HandleScoutingStaffPage edit />,
			path: "/scouting/staffs/:id/edit",
		},
		{component: <HandleScoutingStaffPage />, path: "/scouting/staffs/new"},
		{component: <ScoutingDatabasePage />, path: "/scouting/players"},
		{component: <ScoutingPlayerPage />, path: "/scouting/players/:id"},
		{
			component: <HandleScoutingPlayerPage edit />,
			path: "/scouting/players/:id/edit",
		},
		{component: <HandleScoutingPlayerPage />, path: "/scouting/players/new"},
		{component: <StaffRolesPage />, path: "/settings/staff-roles"},
		{component: <StaffRolePage />, path: "/settings/staff-roles/:id"},
		{component: <HandleStaffRolePage />, path: "/settings/staff-roles/new"},
		{
			component: <HandleStaffRolePage edit />,
			path: "/settings/staff-roles/:id/edit",
		},
		{component: <StaffUnitsPage />, path: "/settings/staff-units"},
		{component: <StaffUnitPage />, path: "/settings/staff-units/:id"},
		{component: <HandleStaffUnitPage />, path: "/settings/staff-units/new"},
		{
			component: <HandleStaffUnitPage edit />,
			path: "/settings/staff-units/:id/edit",
		},
		{component: <UsersPage />, path: "/settings/users"},
		{component: <UserPage />, path: "/settings/users/:id"},
		{component: <HandleUserPage />, path: "/settings/users/new"},
		{component: <UserRolesPage />, path: "/settings/user-roles"},
		{component: <UserRolePage />, path: "/settings/user-roles/:id"},
		{component: <HandleUserRolePage />, path: "/settings/user-roles/new"},
		{component: <ExercisesPage />, path: "/exercises"},
		{component: <ExercisePage />, path: "/exercises/:id"},
		{component: <HandleExercisePage />, path: "/exercises/new"},
		{
			component: <HandleExercisePage edit />,
			path: "/exercises/:id/edit",
		},
		{component: <MovementsPage />, path: "/player-movements"},
		{component: <HandleMovementPage />, path: "/player-movements/new"},
		{
			component: <HandleMovementPage edit />,
			path: "/player-movements/:id/edit",
		},
		{component: <PlayerProfilePage />, path: "/profile/:id"},
		{component: <ManagerFootballTeamsPage />, path: "/manager/teams"},
		{component: <ManagerFootballTeamPage />, path: "/manager/teams/:id"},
		{component: <ManagerHandleFootballTeamPage />, path: "/manager/teams/new"},
		{
			component: <ManagerHandleFootballTeamPage edit />,
			path: "/manager/teams/:id/edit",
		},
		{
			component: <HandleRosterPage source="manager" />,
			path: "/manager/teams/:id/players",
		},
		{
			component: <HandleRosterPage source="manager" type="staffs" />,
			path: "/manager/teams/:id/staffs",
		},
		{component: <ScoutingRostersPage />, path: "/development/rosters"},
		{
			component: <ScoutingRosterPage source="scouting" />,
			path: "/development/rosters/:id",
		},
		{
			component: <ManagerHandleFootballTeamPage source="scouting" />,
			path: "/development/rosters/new",
		},
		{
			component: <ManagerHandleFootballTeamPage source="scouting" edit />,
			path: "/development/rosters/:id/edit",
		},
		{
			component: <HandleRosterPage source="scouting" />,
			path: "/development/rosters/:id/players",
		},
		{
			component: <HandleRosterPage source="scouting" type="staffs" />,
			path: "/development/rosters/:id/staffs",
		},
		{component: <DirectorDashboardPage />, path: "/director/dashboard"},
	];

	if (loading) {
		return <Loading />;
	}

	return (
		<>
			<Routes>
				<Route>
					<Route
						path="/login"
						element={<LoginPage handleNotification={handleNotification} />}
					/>
					{authRoutes.map((route, key) => {
						return (
							<Route
								key={key}
								path={route.path}
								exact
								element={
									<RequireAuth
										isLoggedIn={isLoggedIn}
										handleNotification={handleNotification}
									>
										{route.component}
									</RequireAuth>
								}
							/>
						);
					})}
				</Route>
			</Routes>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				anchorOrigin={{vertical: "bottom", horizontal: "right"}}
				onClose={handleClose}
			>
				<Alert severity={severity}>
					<div>{message}</div>
				</Alert>
			</Snackbar>
		</>
	);
}

export default App;
